// hooks/useMarkdown.js (or same file)
import { useEffect, useState } from "react";

export function useMarkdown(url) {
  const [text, setText] = useState("");
  useEffect(() => {
    let ok = true;
    fetch(url)
      .then(r => (r.ok ? r.text() : Promise.reject(r.status)))
      .then(t => { if (ok) setText(t); })
      .catch(() => { if (ok) setText("*(couldn’t load description)*"); });
    return () => { ok = false; };
  }, [url]);
  return text;
}
